import { motion } from "framer-motion";

export const Marquee = ({ items = [], className = "" }) => {
  const doubled = [...items, ...items];
  return (
    <div className={`overflow-hidden ${className}`} data-testid="editorial-marquee">
      <motion.div
        className="flex whitespace-nowrap will-change-transform"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: 40, repeat: Infinity, ease: "linear" }}
      >
        {doubled.map((item, i) => (
          <span
            key={i}
            className="mx-8 md:mx-14 inline-flex items-center gap-8 md:gap-14 text-5xl md:text-7xl lg:text-8xl font-light tracking-editorial"
          >
            {item}
            <span className="text-accent-foreground/40">—</span>
          </span>
        ))}
      </motion.div>
    </div>
  );
};
